import { Component, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { get, uniqWith } from 'lodash';
import { PedidoConsultaInternaOutput } from 'src/app/@shared/models/consulta-detalhes-interno';
import { BlocoDetalhesInternosComponent } from '../../bloco-detalhes-internos.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-aba-peso-nrt',
  templateUrl: './aba-peso-nrt.component.html',
  styleUrls: ['./aba-peso-nrt.component.scss'],
})
export class AbaPesoNrtComponent {
  static Title = 'Peso da NRT';
  static Concluido = (el: FormGroup) => {
    return true;
  };

  @Input('pedido') pedido: PedidoConsultaInternaOutput;
  @Input() parent: BlocoDetalhesInternosComponent;
  constructor(@Inject(MAT_DIALOG_DATA)
  public data: PedidoConsultaInternaOutput) {
    this.pedido = data ?? this.pedido;
  }

  public grid: MatTableDataSource<any> = new MatTableDataSource<any>();
  public displayedColumns: string[] = [
    'volume',
    'fonte',
    'bruto',
    'cubado',
    'cubadoCalculado',
    'dataPesagem',
  ];
  isLoading: boolean = false;

  spans = {};

  ngOnInit() {
    this.grid.data = this.pedido.pesoNrt;
    this.getSpans();
  }

  getSpans() {
    this.spans = Object.assign(
      {},
      {
        volume: this.spanDeep(['volume'], this.grid.data),
      }
    );
  }

  spanDeep(paths: string[] | null, data: any[]) {
    if (!paths.length) {
      return [...data].fill(0).fill(data.length, 0, 1);
    }
    const copyPaths = [...paths];
    const path = copyPaths.shift();
    const uniq = uniqWith(data, (a, b) => get(a, path) === get(b, path)).map(
      (item) => get(item, path)
    );
    return uniq
      .map((uniqItem) =>
        this.spanDeep(
          copyPaths,
          data.filter((item) => uniqItem === get(item, path))
        )
      )
      .flat(paths.length);
  }

  getRowSpan(path, idx) {
    return this.spans[path][idx];
  }
}
